/* jshint esnext: true */

/**
 * A generic modal library.
 */
const modals = {

	/**
	 * Initialize the modal windows.
	 */
	init: function() {

		this.hideAll();

		$( '.modal-button' ).on(
			'click',
			this.show
		);

		$( '.modal-close' ).on(
			'click',
			this.hide
		);

	},


	/**
	 * Show a modal window.
	 */
	show: function( event ) {

		event.preventDefault();

		let $button = $( this );
		let modal = $button.data( 'modal' );
		let panel = '.modal-' + modal;

		modalsController.set( modal );

		$( panel + ' .state-wrapper' ).show();

		$( panel )
			.removeClass( 'disabled' )
			.addClass( 'active' );

	},


	/**
	 * Hide an individual modal.
	 */
	hide: function( event = null ) {

		if ( event ) {
			event.preventDefault();
		}

		$( '.game-modal .state-wrapper' ).hide();

		$( '.game-modal' )
			.addClass( 'disabled' )
			.removeClass( 'active' );

		setTimeout(
			modals.hideAll,
			250
		);

	},


	/**
	 * Hide all the modals.
	 */
	hideAll: function() {

		$( '.game-modal' )
			.removeClass( 'disabled' )
			.removeClass( 'active' );

	}

};